export default "__VITE_ASSET__2a8397c2__"